module.exports = __webpack_public_path__ + "img/chazet.79eeb654.jpg";